<template>
  <div
    v-if="cardLists && cardLists.length > 0"
    class="payment-wrapper"
  >
    <div class="tabs">
      <button
        type="button"
        :class="{ active_tab: paymentdetails }"
        @click="paymentdetails = true"
      >
        Payment details
      </button>
      <button
        type="button"
        :class="{ active_tab: !paymentdetails }"
        @click="paymentdetails = false"
      >
        Invoice and Billing history
      </button>
    </div>
    <hr>
    <div v-if="paymentdetails">
      <h3>Your payment method</h3>
      <div
        v-for="source in cardLists"
        :key="source"
        class="payment-details"
      >
        <div class="card-div">
          <div card-details>
            <div class="card-vendor">
              Visa Card ending with {{ source.card.last4 }}
            </div>
            <div class="holder-info">
              <span
                class="card-expiry"
              >Expires {{ source.card.exp_month }}/{{
                source.card.exp_year
              }}</span>
            </div>
          </div>
          <button
            type="button"
            class="renew"
            @click="deletecard(source.id)"
          >
            X
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <h3>Invoice History</h3>
      <div
        v-for="invoice in invoiceList.data"
        :key="invoice"
        class="payment-details"
      >
        <div class="card-div">
          <div card-details>
            <div class="card-vendor">
              Invoice number : {{ invoice.number }}
            </div>
            <div class="holder-info">
              <span class="card-expiry">
                {{ new Date(invoice.period_start * 1000).toUTCString() }}
              </span>
              <span
                v-if="invoice.amount_paid > 0"
                class="card-expiry"
              >
                Amount paid: €{{ invoice.amount_paid / 100 }}
              </span>
              <span
                v-else
                class="card-expiry"
              >
                Amount paid: €{{ invoice.amount_paid }}
              </span>
            </div>
          </div>
          <div
            class="download_invoice"
            @click="downloadInvoice(invoice.invoice_pdf)"
          >
            <img src="../../assets/subscription/downloadicon.png">
          </div>
        </div>
      </div>
    </div>
    <teleport to="body" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  
  data() {
    return {
      paymentdetails: true,
      loader: false,
    };
  },
  methods: {
    ...mapActions({
      fetchSavedCard: 'subscription/fetchSavedCard',
      deleteCard: 'subscription/deleteCard',
      fetchHistory: 'subscription/fetchHistory',
    }),
    async deletecard(id) {
      this.loader = true;
      await this.deleteCard({
        cardId: id,
      });
      await this.fetchSavedCard();
      this.loader = false;
    },
    async downloadInvoice(invoiceurl) {
      window.open(invoiceurl, '_blank');
    },
  },
  async created() {
    this.loader = true;
    await this.fetchSavedCard();
    await this.fetchHistory();
    this.loader = false;
  },

  computed: {
    ...mapGetters({
      cardLists: 'subscription/cardLists',
      invoiceList: 'subscription/invoiceList',
    }),
  },
};
</script>

<style scoped>
.download_invoice {
  cursor: pointer;
}
.renew {
  width: 40px;
  height: 34px;
  background: var(--djuli-primary-color);
  border-radius: 5px;
  cursor: pointer;
  border: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  color: #f8fafc;
}
.payment-wrapper > h3 {
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  color: #0f172a;
  padding-bottom: 10px;
}
.card-div {
  padding: 8px;
  width: 440px;
  height: 51px;
  background: #ffffff;
  border: 1px solid #f3f3f3;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tabs {
  display: flex;
}
.tabs > button {
  margin-right: 10px;
  padding-bottom: 10px;
  background: transparent;
  border: none;
  font-family: Inter;
  font-size: 14px;

  color: #475569;
}
.active_tab {
  color: #1d4ed8 !important;
  border-bottom: 1px solid #1d4ed8 !important;
}
.card-vendor {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #334155;
}
.holder-info {
  display: flex;
  justify-content: space-between;
}
.holder-name,
.card-expiry {
  font-family: Inter;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: #334155;
  margin-right: 0.2rem;
}

hr {
  border: 1px solid #e2e8f0;
  margin-bottom: 10px;
}
.payment-details {
  display: flex;
  align-items: center;
}
.add-card,
.edit-card {
  padding: 0 16px;
}
.add-card > a,
.edit-card > a {
  font-family: Inter;
  font-size: 12px;
  color: #30c56f;
}
.or {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #94a3b8;
}
</style>
